const extractFileData = require("./extractFileData");

module.exports = function transformGalleryData(entity, sitemap) {
	let data = {
		id: entity.id,
		type: entity.type,
		images: [],
	};
	if (
		entity.relationships &&
		entity.relationships.field_media &&
		Array.isArray(entity.relationships.field_media.data)
	) {
		data.images = entity.relationships.field_media.data
			.map((media_rel) => {
				const image = media_rel ? extractFileData(media_rel, null, sitemap) : null;
				return image ? { ...image } : null;
			})
			.filter((img) => !!img);
	}
	data.orientation = entity.attributes.field_image_orientation || "square";
	data.cols = entity.attributes.field_columns;
	return data;
};
